import { Link } from 'react-router-dom';
import { useState } from 'react';
import { admin, appointment, billing, customer, faq, finance, home, inventory, manual, request, service, specialEquipment, technician, training, user } from '../lib/icons';

function MenuPreview({color, font}) {

    const [ activeMenu, setActiveMenu ] = useState('Dashboard');

    const access = window.localStorage.getItem('access')
    const menuStyle = 'py-2 px-8 hover:text-customOne text-gray-500 text-md cursor-pointer font-semibold flex gap-2 items-center ml-2';
    const optionStyle = 'py-2 px-8 ml-4 text-gray-500 hover:text-customOne hover:font-semibold';

    function setMenu(e) {
        const value = e.target.innerHTML
        setActiveMenu(value)
    }

    return(
        <div className={`pt-3 flex flex-col bg-white border-r border-gray-200 text-${font.fontSize}`} style={{backgroundColor: color?.secondaryColor?.hex, fontFamily: font.fontFamily}}>
                <Link onClick={e => setMenu(e)} className={menuStyle + ' ' + (activeMenu === 'Dashboard' && 'text-customOne border-l-8 border-customOne rounded-l-md')}>
                        <img src={home} /> 
                        <span>Dashboard</span>
                </Link>
                <div className={menuStyle + ' ' + (activeMenu === 'Admin' && 'text-customOne border-l-8 border-customOne rounded-l-md bg-red-400')} onClick={e => setMenu(e)}>
                    <img src={admin} />
                    <span>Admin</span>
                </div>
                {
                    activeMenu === 'Admin' ?
                    <div>
                        <div className={optionStyle}>
                            <Link>Managers</Link>
                        </div>
                        {/* <div className={optionStyle}>
                            <Link to='/admin/services'>Services</Link>
                        </div> */}
                        <div className={optionStyle}>
                            <Link>Subscriptions</Link>
                        </div>
                        <div className={optionStyle}>
                            <Link>Special Equipment</Link>
                        </div>
                        <div className={optionStyle}>
                            <Link>General Equipment</Link>
                        </div>
                        <div className={optionStyle}>
                            <Link>Holidays</Link>
                        </div>
                        <div className={optionStyle}>
                            <Link>Customize UI</Link>
                        </div>
                    </div> : null
                }
                <Link className={menuStyle + ' ' + (activeMenu === 'Employee' && 'text-customOne border-l-8 border-customOne rounded-l-md')} onClick={e => setMenu(e)}>
                    <img src={user} />
                    <span>Employee</span>
                </Link>
                <div className={menuStyle + ' ' + (activeMenu === 'Directory Management' && 'text-customOne border-l-8 border-customOne rounded-l-md')} onClick={e => setMenu(e)}>
                    <img src={inventory} />
                    <span>Directory Management</span>
                </div>
                {
                    activeMenu === 'Directory Management' ? 
                    <div>
                        <div className={optionStyle}>
                            <Link>Dashboard</Link>
                        </div>
                        <div className={optionStyle}>
                            <Link>Files</Link>
                        </div>
                        <div className={optionStyle}>
                            <Link>Archive Files</Link>
                        </div>
                        <div className={optionStyle}>
                            <Link>Upload</Link>
                        </div>
                        <div className={optionStyle}>
                            <Link>FAQs</Link>
                        </div>
                        <div className={optionStyle}>
                            <Link>Fine-Tune</Link>
                        </div>
                    </div> : null
                }
                <div className={menuStyle + ' ' + (activeMenu === 'Inventory' && 'text-customOne border-l-8 border-customOne rounded-l-md')} onClick={e => setMenu(e)}>
                    <img src={inventory} />
                    <span>Inventory</span>
                </div>
                {
                    activeMenu === 'Inventory' ? 
                    <div>
                        <div className={optionStyle}>
                            <Link>Mobile Vans</Link>
                        </div>
                        <div className={optionStyle}>
                            <Link>Mobile Workshop</Link>
                        </div>
                        <div className={optionStyle}>
                            <Link>Software Updates</Link>
                        </div>
                        <div className={optionStyle}>
                            <Link>Transfers</Link>
                        </div>
                        <div className={optionStyle}>
                            <Link>Locations</Link>
                        </div>
                    </div> : null
                }
                <Link  className={menuStyle + ' ' + (activeMenu === 'Special Equipment' && 'text-customOne border-l-8 border-customOne rounded-l-md')} onClick={e => setMenu(e)}>
                    <img src={specialEquipment} />
                    <span>Special Equipment</span>
                </Link>
                <Link className={menuStyle + ' ' + (activeMenu === 'General Equipment' && 'text-customOne border-l-8 border-customOne rounded-l-md')} onClick={e => setMenu(e)}>
                    <img src={specialEquipment} />
                    <span>General Equipment</span>
                </Link>
                <div className={menuStyle + ' ' + (activeMenu === 'Requests' && 'text-customOne border-l-8 border-customOne rounded-l-md')} onClick={e => setMenu(e)}>
                    <img src={request} />
                    <span>Requests</span>
                </div>
                {
                    activeMenu === 'Requests' ?
                    <div>
                        <div className={optionStyle}>
                            <Link>Leave</Link>
                        </div>
                        <div className={optionStyle}>
                            <Link>Certification</Link>
                        </div>
                        <div className={optionStyle}>
                            <Link>Equipment Reservation</Link>
                        </div>
                        <div className={optionStyle}>
                            <Link>Equipment Checkout</Link>
                        </div>
                        <div className={optionStyle}>
                            <Link>Inventory Transfer</Link>
                        </div>
                        <div className={optionStyle}>
                            <Link>Inventory Checkout</Link>
                        </div>
                        {/* <div className={optionStyle}>
                            <Link to='/requests/work_orders'>Work Orders</Link>
                        </div> */}
                    </div> : null
                }
                <div className={menuStyle + ' ' + (activeMenu === 'Services' && 'text-customOne border-l-8 border-customOne rounded-l-md')} onClick={e => setMenu(e)}>
                    <img src={service} />
                    <span>Services</span>
                </div>
                {
                    activeMenu === 'Services' ?
                    <div>
                        <div className={optionStyle}>
                            <Link>Service Bundle</Link>
                        </div>
                        <div className={optionStyle}>
                            <Link>Service List</Link>
                        </div>
                        <div className={optionStyle}>
                            <Link>Parts List</Link>
                        </div>
                        <div className={optionStyle}>
                            <Link>Others</Link>
                        </div>
                    </div> : null
                }
                <div className={menuStyle + ' ' + (activeMenu === 'Appointments' && 'text-customOne border-l-8 border-customOne rounded-l-md')} onClick={e => setMenu(e)}>
                    <img src={appointment} />
                    <span>Appointments</span>
                </div>
                {
                    activeMenu === 'Appointments' ?
                    <div>
                        <div className={optionStyle}>
                            <Link >Pending</Link>
                        </div>
                        <div className={optionStyle}>
                            <Link>Upcoming</Link>
                        </div>
                    </div> : null
                }
        </div>
    )
}
export default MenuPreview;